import { createAction } from "@reduxjs/toolkit";
import type { ApprovedFundingRequestDetailVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveApprovedFundingRequest = createApiThunk<ApprovedFundingRequestDetailVM, string>(
  "fundingRequests/retrieveApprovedFundingRequest",
  async (id, { extra: { adminRepository } }) => {
    return adminRepository!.getApproved(id);
  },
);

export const resetRetrieveApprovedFundingRequest = createAction("fundingRequests/resetRetrieveApprovedFundingRequest");
